<template>
  <!--文章详情-->
  <div class="pdBtm30 pdTop30">
    <h1 class="tct col101010">{{info.sub_title}}</h1>
    <h4 class="col101010 tct">{{info.add_time}}</h4>
    <div class="fs14 col101010 mrTop20" style="min-height: 45rem">
      <div class="parse" v-html="info.content"></div>
    </div>
    <!--立即报名-->
    <div class="button colfff fs28 pointer difcac" @click="signUp()">
      立即报名
    </div>
  </div>
</template>

<script>
export default {
  name: "school",
  data() {
    return {
      info: {
        "id": 0,
        "name": "",
        "image": "",
        "sub_title": "",
        "add_time": "",
        "content": "",
        "zhuanye_ids": ""
      }
    }
  },
  methods: {
    signUp() { //立即报名
      this.$router.push('/signUp').catch(err => err)
    },
    getDetail(id) { //获取学校详情
      this.$axios("POST","/index/school_info",{id},'加载中')
          .then(res => {
            if(res.code===1) {
              this.info = res.data
            }else {
              this.$alert(res.msg)
            }
          })
    },
  },
  created() {
    let id = this.$route.query.id
    if(id) this.getDetail(id)
  },
}
</script>

<style scoped>
  .button{
    width: 40rem;
    height: 6rem;
    border-radius: 5rem;
    background: #05D7B2;
    margin: 3rem auto;
  }
</style>